module.exports = __webpack_public_path__ + "img/divider.1bb3a499.svg";